module.exports = __webpack_public_path__ + "img/adobe-acrobat.dbcfcd3f.svg";